import React from "react";
import { getInitials } from "../../utils/helpers";

const HeaderAvatarStack = ({ collaborators, maxShow }) => {
  const isMobile = typeof window !== "undefined" && window.innerWidth < 640;
  const displayLimit = maxShow || (isMobile ? 3 : 5);
  
  const displayedCollaborators = collaborators.slice(0, displayLimit);
  const remainingCount = Math.max(0, collaborators.length - displayLimit);

  return (
    <div className="flex items-center">
      <div className="flex -space-x-2">
        {displayedCollaborators.map((collaborator, index) => {
          const avatarSrc = collaborator.picture || collaborator.profile;
          const initials = getInitials(collaborator.name || collaborator.email);

          return (
            <div
              key={collaborator.email || index}
              className="relative w-8 h-8 rounded-full border-2 border-edge-white dark:border-edge-gray-900 bg-fill-gray-200 dark:bg-fill-gray-700 flex items-center justify-center overflow-hidden"
              title={collaborator.name || collaborator.email}
            >
              {avatarSrc ? (
                <img
                  src={avatarSrc}
                  alt={collaborator.name || collaborator.email}
                  className="w-full h-full object-cover"
                />
              ) : (
                <span className="text-xs font-medium text-ink-gray-600 dark:text-ink-gray-300">
                  {initials}
                </span>
              )}
            </div>
          );
        })}
        {remainingCount > 0 && (
          <div
            className="relative w-8 h-8 rounded-full border-2 border-edge-white dark:border-edge-gray-900 bg-fill-gray-300 dark:bg-fill-gray-600 flex items-center justify-center"
            title={`${remainingCount} more collaborator${remainingCount > 1 ? "s" : ""}`}
          >
            <span className="text-xs font-medium text-ink-gray-700 dark:text-ink-gray-200">
              +{remainingCount}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default HeaderAvatarStack;
